import { combineReducers } from 'redux';

import data from './data';
import statistics from './statistics';
import ui from './ui';

/**
 * @typedef {{
 *   data: import('./data').CampaignDataEntity,
 *   statistics:  import("./statistics").CampaignStatisticsReducer,
 *   ui: import("./ui").CampaignUIReducer,
 * }} CampaignReducer
 */

export default combineReducers({
  data,
  statistics,
  ui,
});
